import React, { useEffect, useState } from "react"

export const ModeContext = React.createContext({
  darkMode: false,
  setDarkMode: () => {},
})

const ModeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false)
  const [isInitialized, setIsInitialized] = useState(false)

  useEffect(() => {
    let nextMode = false

    try {
      const storedTheme = window.localStorage.getItem("theme")
      if (storedTheme === "dark") {
        nextMode = true
      } else if (storedTheme === "light") {
        nextMode = false
      } else {
        nextMode = window.matchMedia("(prefers-color-scheme: dark)").matches
      }
    } catch (error) {
      nextMode = false
    }

    setDarkMode(nextMode)
    document.documentElement.classList.toggle("dark", nextMode)
    setIsInitialized(true)
  }, [])

  useEffect(() => {
    if (!isInitialized) return

    document.documentElement.classList.toggle("dark", darkMode)
    try {
      window.localStorage.setItem("theme", darkMode ? "dark" : "light")
    } catch (error) {
      // Ignore localStorage errors (private mode/restricted environments).
    }
  }, [darkMode, isInitialized])

  return (
    <ModeContext.Provider value={{ darkMode, setDarkMode }}>
      {children}
    </ModeContext.Provider>
  )
}

export default ModeProvider
